<template>
  <div id="app-main">
    <header-container 
      v-if="loaded"
      />
    <router-view/>
  </div>
</template>

<script>
import HeaderContainer from './components/ui/HeaderContainer.vue'

export default {
  components: { HeaderContainer }
}
</script>
<style lang="scss">
@use 'assets/scss/style';
</style>

